var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightningBoltLarge(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 172,
    viewBox: "0 0 134 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M128.411 -11C129.193 -11 129.976 -11 130.759 -10.8037C133.696 -10.2147 134.87 -7.4661 133.304 -5.30652C132.913 -4.91387 132.717 -4.52127 132.325 -4.12862L83.9768 51.0387C83.9768 51.0387 82.9981 52.0203 82.8024 52.4129C81.0407 54.9651 82.8024 57.9101 86.13 58.1064H87.6959H104.334H105.9C109.228 58.499 110.794 61.444 109.032 63.7999C108.64 64.3888 107.662 65.3706 107.662 65.3706L72.0365 105.617C71.645 106.01 71.2535 106.599 70.862 107.188C69.2961 109.544 71.0578 112.489 74.3854 112.685H87.3045C89.0662 112.489 90.6321 113.47 91.415 115.041C92.0023 116.415 91.6108 118.182 90.4363 119.163C90.0448 119.556 89.4576 119.949 89.4576 119.949L6.85409 182.38C6.85409 182.38 5.87533 183.362 5.28811 183.558C4.50513 184.147 3.52644 184.147 2.74347 183.558C1.9605 183.166 1.76477 182.38 1.96051 181.595C2.15625 181.006 2.74347 180.024 2.74347 180.024L25.4497 133.103L26.0369 131.728C27.6028 128.587 26.0369 126.035 22.7093 125.642H21.3391H5.48386C4.89663 125.642 4.11366 125.642 3.52643 125.446C0.786027 125.053 -0.779929 122.698 0.394529 120.342C0.590272 119.753 1.17755 118.771 1.17755 118.771L29.3645 71.2603C29.3645 71.2603 29.756 70.6713 29.756 70.475C31.3219 67.7264 29.3645 64.9778 25.8411 64.9778H21.3391H8.81152H7.24554C4.89662 64.9778 3.13496 63.7999 2.74347 61.8366C2.54773 60.855 2.9392 59.8733 3.52643 59.088L12.1391 43.9711L40.3262 -5.89559L41.1091 -7.0735C42.4793 -9.62572 45.0239 -11 48.3516 -11H128.411Z",
    fill: "url(#paint0_linear_1017_27853)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1017_27853",
    x1: 67,
    y1: -11,
    x2: 67,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBoltLarge);
export default __webpack_public_path__ + "assets/media/lightning-bolt-large.e1729e26.svg";
export { ForwardRef as ReactComponent };